var exports = {
  "k": "xa9f3555f--7a581b--container",
  "X": "xa9f3555f--7a581b--container_mobile",
};

module.exports = exports;
